import { z } from 'zod';
import { VALID_ROLES } from '../constants/roles.js';

/**
 * Login request schema
 */
export const loginSchema = z.object({
  email: z.string().email('Invalid email address'),
  password: z.string().min(1, 'Password is required'),
});

export type LoginRequest = z.infer<typeof loginSchema>;

/**
 * Create user request schema (admin only)
 */
export const createUserSchema = z.object({
  email: z.string().email('Invalid email address'),
  full_name: z.string().min(1, 'Full name is required'),
  role: z.enum(VALID_ROLES as [string, ...string[]], {
    errorMap: () => ({ message: 'Invalid role' }),
  }),
});

export type CreateUserRequest = z.infer<typeof createUserSchema>;